import { useTranslation } from "react-i18next";

export interface DescriptionSummaryProps {
  description: string;
}

export function DescriptionSummary({ description }: DescriptionSummaryProps) {
  const { t } = useTranslation("search");

  if (!description.trim()) return null;

  return (
    <div className="bg-primary/8 rounded-md px-3.5 py-2.5 mb-4 border-l-[3px] border-primary">
      <div className="text-[0.6875rem] font-semibold text-muted-foreground uppercase tracking-wider mb-0.5">
        {t("wizard.descriptionSummary.label")}
      </div>
      <p className="text-[0.8125rem] text-foreground">{description}</p>
    </div>
  );
}
